import React from 'react'

export default function Area() {
    return (
        <section className="country-section pb-100">
        <div className="container">
            <div className="section-title">
                <span>
                    <i className="flaticon-selection"></i>
                    Our Area
                </span>
                <h2>Children Facilities</h2>
                <p>
                Child Hope international children ministries is located in the parish of Lubya in the Lubaga Division of Kampala. We give the well-being of the poor, homeless children in our society, community and newcomers top priority.
                </p>
            </div>
            <div className="map-img">
                <img src="./assets/img/map.png" alt="map"/>

                <div className="location">
                    <a href="_">
                        <div className="location-info">
                            <h5>Hoima</h5>
                        </div>
                    </a>
                </div>

                <div className="location location2">
                    <a href="_">
                        <div className="location-info">
                            <h5>Kampala</h5>
                        </div>
                    </a>
                </div>

                <div className="location location3">
                    <a href="_">
                        <div className="location-info">
                            <h5>Masaka</h5>
                        </div>
                    </a>
                </div>

                <div className="location location4">
                    <a href="_">
                        <div className="location-info">
                            <h5>Bwaise</h5>
                        </div>
                    </a>
                </div>

                <div className="location location5">
                    <a href="_">
                        <div className="location-info">
                            <h5>Karamoja</h5>
                        </div>
                    </a>
                </div>

                <div className="location location6">
                    <a href="_">
                        <div className="location-info">
                            <h5>Mbale</h5>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>
    )
}
